import SealdContextProvider from "@recare/core/seald/SealdContext";
import { AppType } from "@recare/core/types";
import { useEnvContext } from "context/EnvContext";
import { RefreshBannerSealdSDK } from "dsl/atoms/RefreshBanners";
import { useApolloClient } from "react-apollo";
import { useOnLogout } from "reduxentities/actions";
import { useConnecterWithLoggedAccount } from "reduxentities/selectors/hooks";

export default function WebSealdContextProvider({
  app,
  children,
}: {
  app: AppType;
  children: React.ReactNode;
}) {
  const loggedAccount = useConnecterWithLoggedAccount({ cacheOnly: true });
  const envContext = useEnvContext();
  const onLogout = useOnLogout();
  const client = useApolloClient();

  return (
    <SealdContextProvider
      loggedAccount={loggedAccount}
      envContext={envContext}
      app={app}
      onLogout={onLogout}
      apolloClient={client}
    >
      <RefreshBannerSealdSDK />
      {children}
    </SealdContextProvider>
  );
}
